import {
    OurServiceIconsS1,
    OurServiceIconsS2,
    OurServiceIconsS3,
    OurServiceIconsS4,
} from '../../helpers/allImgs'

const OurServiceContent = [
    {
        img:OurServiceIconsS1,
        title:"Set up your wallet",
        text:"it is required to install Metamask wallet as a browser extension, Then you should configure Metamask to connect to required ETH Network."
    },
    {
        img:OurServiceIconsS2,
        title:"NFT Art Minting Services",
        text:"Mint your NFT assets with included IPFS with easiest way, just upload and fill your nft info and click the mint button, and Happpy Minting !"
    },
    {
        img:OurServiceIconsS3,
        title:"List Your NFT Items",
        text:"once you click the mint button the metamask wallet will pop up to confirm the minting function, just confirm and your nft will be listed"
    },
    {
        img:OurServiceIconsS4,
        title:"Buy and Sell NFTs",
        text:"once the item is listed, congrats! Now you are ready to sell and buy NFTs, You just need to specify your NFT Price and click offer"
    }
]

export default OurServiceContent